import alt from "../alt";
import AvailabilityActions from "../actions/AvailabilityActions";

import ImmutableUtil from "alt-utils/lib/ImmutableUtil";
import LocalStore from 'alt-localstore';
import Immutable from 'immutable';

// https://stackoverflow.com/a/25490531
function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

// https://www.npmjs.com/package/thenby
var firstBy = (function() {

    function identity(v){return v;}

    function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

    function makeCompareFunction(f, opt){
        opt = typeof(opt)==="number" ? {direction:opt} : opt||{};
        if(typeof(f)!="function"){
            var prop = f;
            // make unary function
            f = function(v1){return !!v1[prop] ? v1[prop] : "";}
        }
        if(f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase?ignoreCase:identity;
            var cmp = opt.cmp || function(v1,v2) {return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;}
            f = function(v1,v2) {return cmp(preprocess(uf(v1)), preprocess(uf(v2)));}
        }
        if(opt.direction === -1) return function(v1,v2){return -f(v1,v2)};
        return f;
    }

    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */
    function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the
        exported function, or the firstBy property on it (for es6 module compatibility)
        */
        var x = (typeof(this) == "function" && !this.firstBy) ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
                        return x(a,b) || y(a,b);
                    }
                  : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
})();


class AvailabilityStore {

  constructor() {
    this.exportPublicMethods({
      setState: this.setState
    });

    var defaults = this._getDefaults();
    
    //if signup sends back an error query string, reset prequal key by wiping localstorage
    var params = new URLSearchParams(window.location.search);
    if (params.has('ordererror') && params.get('ordererror') == 'true') {
      localStorage.removeItem('AvailabilityStore');
    }

    var prevState, loaded_from_previous_state;
    if(localStorage.getItem('AvailabilityStore') && localStorage.getItem('AvailabilityStore') !== "null") {
      prevState = JSON.parse(localStorage.getItem('AvailabilityStore'));

      if(prevState.order_placed && prevState.prequal_starttime + (24 * 60 * 60 * 1000) < new Date() && prevState.input_address.serviceType == 'residential') {
        prevState.order_placed = false;
        localStorage.setItem('AvailabilityStore', JSON.stringify(prevState));
        prevState = Immutable.fromJS(prevState);
        defaults = prevState;
        loaded_from_previous_state = true;
      }
      else {
        localStorage.removeItem('AvailabilityStore');
      }
    }

    if(!loaded_from_previous_state) {
      // auto prequal
      if(window.auto_prequal && Object.keys(window.auto_prequal_input).length) {
        defaults = defaults.set('auto_prequal', true);
        defaults = defaults.set('extraData', window.auto_prequal_input.extra_data);
        defaults = defaults.set('srid', window.auto_prequal_input.srid);
        defaults = defaults.set('referralCode', window.referral_code);
        defaults = defaults.set('input_address', Immutable.Map({
          streetAddress: window.auto_prequal_input.street_address,
          zip: window.auto_prequal_input.zip_code,
          secondary: window.auto_prequal_input.secondary,
          serviceType: window.auto_prequal_input.service_type,
          city: window.auto_prequal_input.smcity,
          state: window.auto_prequal_input.state,
          streetAddress_valid: true,
          zip_valid: true,
          verificationRan: true
        }));
      }
    }

    // experiments A/B testing
    // define experiments with id and list of variations
    // Items defined in the array are always available. Item added by if statements are constrained by the conditions imposed.
    let experiments = [];

    // const SP4658EndDate = '2021-03-07'; // Since we aren't from a DB yet, put the code here so we can use it for setting/removing exposures.

    // /////              Start Date                             End Date


    // if(( new Date > (new Date("2021-01-05")) && new Date < (new Date(SP4658EndDate))
    //   )
    //   || window.app_env == 'development'
    // ) {
    //   experiments.push({id: "ShowPreOrderGoLiveDate_SP4658", v: ['A', 'B'], expDate : SP4658EndDate});  // no change vs Show go_live date
    // }

    // // select a variation for all experiments
    // // (persisted exposure will overwrite that subsequently)
    let exposure = experiments.map(function(x) {
      x.v = x.v[Math.floor(Math.random() * Math.floor(x.v.length))]
      return x; // Normally this is x, but here we want to force all tests to B
    });
// //    in some cases in production, sso users should always be given exposure A, which is the 'default'

    if(window.sso_user && window.app_env == 'production') {
      experiments.map(function(x) {
        x.v = 'A';
        return x;
      });
    }
    else { // To force a promo leave in ... -- remember app_env is development, so this will trigger even though you have sso_user set.

    } // ... To force a promo leave in

    if (getCookieValue("SESSexposure")) {
      let persisted_exposure = JSON.parse(decodeURIComponent(getCookieValue("SESSexposure")));
      persisted_exposure = persisted_exposure.filter(function(exp) { return exp; });

      for(let i = 0; i < persisted_exposure.length; i++) {
          let f = experiments.findIndex(function(el) { return el && el.id == persisted_exposure[i].id});
          // removes expired exposures
          if(f === -1 || new Date >= (new Date (exposure[i].expDate)) ) { // exposure[i] is set above and not the persisted one in the cookie.
            delete exposure[i];
            continue;
          }

          let j = exposure.findIndex(function(el) { return el && el.id == persisted_exposure[i].id });
          if(j != -1) {
              exposure[j].v = persisted_exposure[i].v;
          }
      }
      exposure = exposure.filter(function(exp) { return exp; });

    }

    defaults = defaults.set('exposure', exposure);

    // persist exposure cookie. NOTE: Cookie doesn't set on local host unless you mess with domain. Normally, A/B testing is best to force the result above.
    let domain = (window.cookie_domain ? window.cookie_domain : 'sonic.com');
    let expires = (new Date);
    expires.setTime((new Date).getTime()+(61*24*60*60*1000)); // Set to 61 days so the cookie itself doesn't end up expiring before a normal A/B exposure test would.
    document.cookie = "SESSexposure="+encodeURIComponent(JSON.stringify(exposure))+"; domain="+domain+"; path=/; expires="+expires.toUTCString();

    this.state = defaults;

    this.bindListeners({
      handleUpdateStreetAddress: AvailabilityActions.updateStreetAddress,
      handleUpdateSecondary: AvailabilityActions.UPDATE_SECONDARY,
      handleUpdateZip: AvailabilityActions.UPDATE_ZIP,
      handleSuggestionSelected: AvailabilityActions.SUGGESTION_SELECTED,
      handleAddressVerified: AvailabilityActions.ADDRESS_VERIFIED,
      handleUpdateServiceType: AvailabilityActions.UPDATE_SERVICE_TYPE,

      handlePrequalStarted: AvailabilityActions.PREQUAL_STARTED,
      handlePrequalNotReady: AvailabilityActions.PREQUAL_NOT_READY,

      handleServiceAvailable: AvailabilityActions.SERVICE_AVAILABLE,


      handleCloseMduModal: AvailabilityActions.CLOSE_MDU_MODAL,
      handleOpenMduModal: AvailabilityActions.OPEN_MDU_MODAL,

      handleUpdateContactInfo: AvailabilityActions.UPDATE_CONTACT_INFO,
      handleGetContactInfoErrors: AvailabilityActions.VALIDATE_CONTACT_INFO,

      handleShowMoreFields: AvailabilityActions.SHOW_MORE_FIELDS,

      handleCloseSquallMduModal: AvailabilityActions.CLOSE_SQUALL_MDU_MODAL,

      handleContinuePrequal: AvailabilityActions.CONTINUE_PREQUAL,

      handleSetVideoPlaying: AvailabilityActions.SET_VIDEO_PLAYING,

      handleSetBailOutForm: AvailabilityActions.SET_BAIL_OUT_FORM,

      handleSetPrequalStage: AvailabilityActions.SET_PREQUAL_STAGE,

      handleContactMeSuccess: AvailabilityActions.CONTACT_ME_SUCCESS,

      handleGotForm: AvailabilityActions.GOT_FORM,

      handleContinueConfigure: AvailabilityActions.CONTINUE_TO_CONFIGURE,

      handleUpdateBusinessSeats: AvailabilityActions.UPDATE_BUSINESS_SEATS,

      handleBackToStepOne: AvailabilityActions.BACK_TO_STEP_ONE,
      handleNotMyAddr: AvailabilityActions.NOT_MY_ADDR,

      handleOrderPlaced: AvailabilityActions.ORDER_PLACED,

      setPreOrderCollapseState: AvailabilityActions.SET_PRE_ORDER_COLLAPSE_STATE,

      showVoiceOnly: AvailabilityActions.SHOW_VOICE_ONLY,
      showAdditionalProducts: AvailabilityActions.SHOW_ADDITIONAL_PRODUCTS,

      showBusinessType: AvailabilityActions.SHOW_BUSINESS_TYPE,
      hideBusinessType: AvailabilityActions.HIDE_BUSINESS_TYPE,

      handleReQualSmallBusiness: AvailabilityActions.RE_QUAL_SMALL_BUSINESS,

      selectSquallSuggestion: AvailabilityActions.SELECT_SQUALL_SUGGESTION,
      closeSquallSuggestionsModal: AvailabilityActions.CLOSE_SQUALL_SUGGESTIONS_MODAL
    });

  }

  _getDefaults() {

    var state = Immutable.Map({
      exposure: Immutable.List([]),
      redirect: false,
      auto_prequal: false,
      serviceAvailable: false,
      serviceUnavailableReason: '',
      qualTempUnavail: false,
      maintenance_window: false,

      verified_address: Immutable.Map({}),
      qualified_address: Immutable.Map({}),
      postal_address: Immutable.Map({}),
      selectedProduct: Immutable.Map({}),
      products:  Immutable.List([]),

      contact_info: Immutable.Map({
        contact_type: 'contact'
      }),
      contactThanks: false,
      business_seats: 0,
      fusion_available: false,
      fttn_available: false,
      fiber_xgspon_available: false,
      fiber_available: false,
      fiber_product: false,
      voice_only_available: false,

      business_submit_target: (window.business_submit_target ? window.business_submit_target :
                                  (window.location.pathname.indexof('availability2') >= 0 ?
                                      "https://www.sonic.com/availability" :
                                      "https://www.sonic.com/availability2"
                                  )
                              ),
      signup_submit_target: (window.signup_submit_target ? window.signup_submit_target : "https://signup.sonic.com"),

      showMduModal: false,

      form_token: '',
      form_build_id: '',

      showConfigure: false,

      errors: Immutable.Map({
        contact_info: Immutable.Map({})
      }),

      verification_failed: false,

      addressNotFound: false,

      showSquallMduModal: false,
      showSquallSuggestionsModal: false,
      squallSuggestionSelected: null,
      qual_suggestions: Immutable.List([]),

      install_path: (window.install_path ? window.install_path : '/altavailability/build'),
      api_path: (window.api_path ? window.api_path : '/altavailability/api.php'),

      postData: Immutable.Map({
          qualified_address: Immutable.Map({}),
          postal_address: Immutable.Map({}),
          input_address: Immutable.Map({}),
          addon: '',
          sso_user: '',
          sonic_elq_customerID: '',
          product: '',
          metadata: {
            response_tracking_key: '',
            response: '',
            response_hash: ''
          }
      }),

      input_address: Immutable.Map({
        streetAddress: "",
        zip: "",
        secondary: "",
        serviceType: "residential"
      }),
      service_type_manually_selected: false,

      suggestions: Immutable.List([]),
      errorMessage: null,

      prequalInProgress: false,

      mduModalDismissed: false,

      prequal_starttime: null,
      prequal_stage: 0,

      prequal_tracking_key: '',

      lastPrequal: Immutable.Map({}),
      reseller: Immutable.List([]),

      async_id: "",
      order_placed: false,

      sso_user: window.sso_user || '',
      sonic_elq_customerID: window.sonic_elq_customerID || '',
      coupon_code: window.coupon_code || '',
      referral_code: window.referral_code || '',

      suggestions_on: window.return_suggestions || false,
      return_suggestions: window.return_suggestions || false,

      coupon: Immutable.fromJS(window.coupon) || {},

      show_voice_only: false,
      show_preorder: 'collapse',
      show_additional_products: false,
      common_promo: Immutable.Map({}),

      show_business_type: false,

      bailOutForm: false,
      videoPlaying: false,
      resellerLogos: Immutable.Map({
        omsoft: "/sites/all/themes/contrib/sonic/images/resellers/omlogo.jpg",
        mcn: "/sites/all/themes/contrib/sonic/images/resellers/mcn.png",
        pacinet: "/sites/all/themes/contrib/sonic/images/resellers/pacinet.gif",
        coastsid: "/sites/all/themes/contrib/sonic/images/resellers/coastside.gif",
        cruzio: "/sites/all/themes/contrib/sonic/images/resellers/cruzio.jpg",
        spirals: "/sites/all/themes/contrib/sonic/images/resellers/spirals.png",
        calnet: "/sites/all/themes/contrib/sonic/images/resellers/cal-netx200.gif",
        dslextreme: "/sites/all/themes/contrib/sonic/images/resellers/dslx.png",
        connectto: "/sites/all/themes/contrib/sonic/images/resellers/connectto_logo.jpg"
      }),

      coupon_history: Immutable.fromJS( (window.coupon_history ? window.coupon_history : []) ),
      fusion_fiber_data_flat_rate_available: false

    });

    return state;
  }

  selectSquallSuggestion(i) {
    if(i === null) {

      this.setState(this.state.set('squallSuggestionSelected', null));
      this.setState(this.state.set('input_address', Immutable.fromJS({
        streetAddress: this.state.getIn(['lastPrequal', 'request', 'streetAddress']),
        secondary: this.state.getIn(['lastPrequal', 'request', 'secondary']),
        city: this.state.getIn(['lastPrequal', 'request', 'city']),
        human_city: this.state.getIn(['lastPrequal', 'request', 'human_city']),
        state: this.state.getIn(['lastPrequal', 'request', 'state']),
        zip: this.state.getIn(['lastPrequal', 'request', 'zip']),
        serviceType: this.state.getIn(['input_address', 'serviceType']),
        streetAddress_valid: true,
        zip_valid: true,
        verificationRan: true
      })));
    } else {
      var s = this.state.get('qual_suggestions').toJS()[i];
      this.setState(this.state.set('squallSuggestionSelected', i));
      this.setState(this.state.set(
        'input_address',
        Immutable.fromJS(Object.assign(
          {},
          this.state.get('input_address').toJS(),
          {
            streetAddress: [s.SrvcAddrHousNbr, s.SrvcAddrHousNbrSufx, s.SrvcAddrStDrctl, s.SrvcAddrStName, s.SrvcAddrStThoroughfare].filter((i) => !!i).join(' '),
            secondary: [s.LocationDesignator1, s.LocationValue1, s.LocationDesignator2, s.LocationValue2].filter((i) => !!i).join(' '),
            city: s.SrvcAddrCity,
            human_city: s.human_city,
            state: s.SrvcAddrState,
            zip: s.SrvcAddrZipCd
          },
          s
        ))
      ))

    }
  }

  closeSquallSuggestionsModal() {
    this.setState(this.state.set('showSquallSuggestionsModal', false));
  }

  showAdditionalProducts() {
    this.setState( this.state.set('show_additional_products', true) );
  }

  showVoiceOnly() {
    this.setState( this.state.set('show_voice_only', true) );
  }

  setPreOrderCollapseState(collapse_state) {
    this.setState( this.state.set('show_preorder', collapse_state) );
  }

  handleOrderPlaced() {
    this.setState( this.state.set('order_placed', true) );
  }

  handleBackToStepOne() {
    var input_address = this.state.get('input_address');
    input_address = input_address.set('verificationRan', false);
    var verified_address = this.state.get('verified_address');
    var extraData = this.state.get('extraData');
    var srid = this.state.get('srid');
    var referralCode = this.state.get('referralCode');

    var defaults =  this._getDefaults();

    defaults = defaults.set('input_address', Immutable.fromJS({
      streetAddress: input_address.get('streetAddress'),
      secondary: input_address.get('secondary'),
      city: input_address.get('city'),
      state: input_address.get('state'),
      zip: input_address.get('zip'),
      serviceType: input_address.get('serviceType'),
      streetAddress_valid: true,
      zip_valid: true,
      verificationRan: true
    }));
    defaults = defaults.setIn(['input_address', 'verified'], true);
    defaults = defaults.set('verified_address', verified_address);

    defaults = defaults.set('extraData', extraData);
    defaults = defaults.set('srid', srid);
    defaults = defaults.set('referralCode', referralCode);

    if(this.state.getIn(['input_address', 'serviceType']) == 'small_business') {
      defaults = defaults.setIn(['input_address', 'serviceType'], 'business');
      defaults = defaults.set('serviceType', 'business');
      defaults = defaults.set('service_type_manually_selected', false);
    }

    defaults = defaults.set('exposure', this.state.get('exposure'));

    this.setState( defaults );
  }

  handleNotMyAddr() {
    return this.handleBackToStepOne();
  }

  handleReQualSmallBusiness() {
    this.setState(this.state.set('serviceAvailable', false));
  }

  handleUpdateBusinessSeats(seats) {
    this.setState(this.state.set('business_seats', seats));
  }

  handleContinueConfigure() {
    this.setState(this.state.set('showConfigure', true));
  }

  handleGotForm(form) {
    this.setState(this.state.set('form_token', form.form_token));
    this.setState(this.state.set('form_build_id', form.form_build_id));
  }

  handleContactMeSuccess() {
    this.setState(this.state.set('contactThanks', true));
  }

  handleSetVideoPlaying(state) {
    this.setState(this.state.set('videoPlaying', state));
  }

  handleSetBailOutForm(state) {
    this.setState(this.state.set('bailOutForm', state));
  }

  handleSetPrequalStage(state) {
    this.setState(this.state.set('prequal_stage', state));
  }

  handleCloseSquallMduModal() {

    this.setState(this.state.set('showSquallMduModal', false));

    if(this.state.getIn(['lastPrequal', 'request', 'secondary']) == this.state.getIn(['input_address', 'secondary'])) {
      this._handlePrequalResult(this.state.get('lastPrequal').toJS());
    }


  }

  /*
  this is so tangled oh my god
  */
  handleUpdateContactInfo(tuple) {
    var key = tuple[0];
    var val = tuple[1];

    this.setState(this.state.setIn(['contact_info', key], val));

    this._validateContactInfo();
  }

  _validateContactInfo() {

    this.setState(this.state.setIn(['contact_info', 'is_valid'], true));

    if(!this.state.getIn(['contact_info', 'first_name']) || this.state.getIn(['contact_info', 'first_name']).trim().length < 1) {
      this.setState(this.state.setIn(['contact_info', 'is_valid'], false));
      return;
    }

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!this.state.getIn(['contact_info', 'email_address']) || !re.test(this.state.getIn(['contact_info', 'email_address']))) {
      this.setState(this.state.setIn(['contact_info', 'is_valid'], false));
      return;
    }

    if (this.state.getIn(['input_address', 'serviceType']).indexOf('business') >= 0) {

      if(!this.state.getIn(['contact_info', 'last_name']) || this.state.getIn(['contact_info', 'last_name']).trim().length < 2) {
        this.setState(this.state.setIn(['contact_info', 'is_valid'], false));
        return;
      }
    }

    if ('undefined' !== typeof this.state.getIn(['contact_info', 'phone_number']) && this.state.getIn(['contact_info', 'phone_number']).trim().length > 0) {
      var phone = this.state.getIn(['contact_info', 'phone_number']).replace(/[^0-9]/g, '');
      if (phone.length < 10) {
        this.setState(this.state.setIn(['contact_info', 'is_valid'], false));
        return;
      }
    }

    if(this.state.get('show_business_type')) {

      if('undefined' == typeof this.state.getIn(['contact_info', 'workstations']) || this.state.getIn(['contact_info', 'workstations']) == 'Select') {
        this.setState(this.state.setIn(['contact_info', 'is_valid'], false));
        return;
      }

      if('undefined' == typeof this.state.getIn(['contact_info', 'phones']) || this.state.getIn(['contact_info', 'phones']) == 'Select') {
        this.setState(this.state.setIn(['contact_info', 'is_valid'], false));
        return;
      }
    }
  }

  handleGetContactInfoErrors() {
    if(this.state.getIn(['contact_info', 'first_name'])) {
      this.setState(this.state.setIn(['errors', 'contact_info', 'first_name'], (this.state.getIn(['contact_info', 'first_name']).trim().length < 1 ? true : false) ));
    }

    if(this.state.getIn(['contact_info', 'last_name'])) {
      this.setState(this.state.setIn(['errors', 'contact_info', 'last_name'], (this.state.getIn(['contact_info', 'last_name']).trim().length < 2 ? true : false) ));
    }

    if(this.state.getIn(['contact_info', 'email_address'])) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.setState(this.state.setIn(['errors', 'contact_info', 'email_address'], (re.test(this.state.getIn(['contact_info', 'email_address'])) ? false : true) ));
    }

    if (this.state.getIn(['input_address', 'serviceType']).indexOf('business') >= 0 || ('undefined' !== typeof this.state.getIn(['contact_info', 'phone_number']) && this.state.getIn(['contact_info', 'phone_number']).trim().length > 0)) {
      if(this.state.getIn(['contact_info', 'phone_number'])) {
        var phone = this.state.getIn(['contact_info', 'phone_number']).replace(/[^0-9]/g, '');
        if (phone.length < 10) {
          this.setState(this.state.setIn(['errors', 'contact_info', 'phone_number'], true));
        } else {
          this.setState(this.state.setIn(['errors', 'contact_info', 'phone_number'], false));
        }
      }
    } else {
      this.setState(this.state.setIn(['errors', 'contact_info', 'phone_number'], false));
    }

    if('undefined' !== typeof this.state.getIn(['contact_info', 'workstations'])) {
      if(this.state.getIn(['contact_info', 'workstations']) == 'Select') {
        this.setState(this.state.setIn(['errors', 'contact_info', 'workstations'], true));
        return;
      } else {
        this.setState(this.state.setIn(['errors', 'contact_info', 'workstations'], false));
      }
    }

    if('undefined' !== typeof this.state.getIn(['contact_info', 'phones'])) {
      if(this.state.getIn(['contact_info', 'phones']) == 'Select') {
        this.setState(this.state.setIn(['errors', 'contact_info', 'phones'], true));
        return;
      } else {
        this.setState(this.state.setIn(['errors', 'contact_info', 'phones'], false));
      }
    }
  }

  handleShowMoreFields() {

    if(this.state.getIn(['contact_info', 'email_address'])) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.setState(this.state.setIn(['show', 'contact_input'], (re.test(this.state.getIn(['contact_info', 'email_address'])) ? true : false) ));
    }

  }

  handlePrequalStarted() {
    this.setState(this.state.set('prequal_starttime', new Date().getTime() / 1000 ));
    this.setState(this.state.set('prequalInProgress', true));
  }

  handlePrequalNotReady() {

    var seconds_since_start = (new Date().getTime() / 1000) - this.state.get('prequal_starttime');

    if(seconds_since_start >= 10 && this.state.get('prequal_stage') == 0) {
      this.setState(this.state.set('prequal_stage', 1));
      return;
    }

    // after 30sec
    if(seconds_since_start >= 30 && this.state.get('prequal_stage') == 1) {
      this.setState(this.state.set('prequal_stage', 2));
      return;
    }

    // after 45sec
    if(seconds_since_start >= 45 && this.state.get('prequal_stage') == 2) {
      this.setState(this.state.set('prequal_stage', 3));
      this.setState(this.state.set('bailOutForm', true));
      return;
    }

    // after 2min
    if(seconds_since_start >= 120 && this.state.get('prequal_stage') == 3) {
      this.setState(this.state.set('prequal_stage', 4));
      return;
    }

    // after 5min
    if(seconds_since_start >= 300 && this.state.get('prequal_stage') == 4) {
      this.setState(this.state.set('prequal_stage', 5));
      return;
    }
  }

  handleOpenMduModal() {
    this.setState(this.state.set('showMduModal', true));
  }

  handleCloseMduModal() {
    this.setState(this.state.set('showMduModal', false));
    this.setState(this.state.set('mduModalDismissed', true));
  }

  handleUpdateServiceType(service_type) {
    this.setState(this.state.setIn(['input_address', 'serviceType'], service_type));
    this.setState(this.state.set('serviceType', service_type));
    this.setState(this.state.set('service_type_manually_selected', true));
  }

  handleServiceAvailable(result) {
    this.setState(this.state.set('prequalInProgress', false));
    this.setState(this.state.set('errorMessage', ""));

    this.setState(this.state.set('async_id', result.async_id));

    // check to see if products are available. if not render what needs to be shown
    if(typeof result.response == 'undefined') {
      this.setState(this.state.set('qualTempUnavail', true));

      this.setState(this.state.setIn(['contact_info', 'contact_type'], (this.state.getIn(['input_address', 'serviceType']) == 'business' ? 'bustempunavail' : 'restempunavail') ));

      return true;
    }
    else if(result.status == 'ERROR') {
      // error

      if(result.response.error_code == "QUAL_INVALID_ADDRESS") {
        this.setState(this.state.set('addressNotFound', true));
        this.setState(this.state.setIn(['contact_info', 'contact_type'], (this.state.getIn(['input_address', 'serviceType']) == 'business' ? 'busnotyet' : 'resnotyet') ));
        /*
          if source was gigabit (a la availability/gigabit, etc), append 'gig' to the end of contact_type
        */
      }
      else if(result.response.error_code == "QUAL_TEMPORARILY_UNAVAILABLE" || result.response.error_code == "QUAL_SYSTEM_OFFLINE") {
        this.setState(this.state.set('qualified_address', Immutable.Map(result.response.qualified_address)));
        this.setState(this.state.set('postal_address', Immutable.Map(result.response.postal_address)));
        this.setState(this.state.set('qualTempUnavail', true));

        if(result.response.maintenance_window) {
          this.setState(this.state.set('maintenance_window', true));
        }

        this.setState(this.state.setIn(['contact_info', 'contact_type'], (this.state.getIn(['input_address', 'serviceType']) == 'business' ? 'bustempunavail' : 'restempunavail') ));
      }
      else if(result.response.error_code == "BAD_REQUEST") {
        this.setState(this.state.set('errorMessage', "common:bad_request"));
      }
      else {
        this.setState(this.state.set('qualTempUnavail', true));

        this.setState(this.state.setIn(['contact_info', 'contact_type'], (this.state.getIn(['input_address', 'serviceType']) == 'business' ? 'bustempunavail' : 'restempunavail') ));
      }

      return true;
    }

    delete result.async_id;

    result.request = this.state.get('input_address');

    this.setState(this.state.set('lastPrequal', Immutable.fromJS(result)));

    this.setState(this.state.set('prequal_tracking_key', this.state.get('async_id')));
    this.setState(this.state.set('serviceAvailable', result.response.service_available));
    this.setState(this.state.set('qualified_address', Immutable.Map(result.response.qualified_address)));

    //  Squall may _not_ return a qualified address if the address is not exactly found but it's in an
    // in_service service_area. So, for now, calling the input_address the qualified address. ugh.
    // e.g. 520 Sebastopol Ave, 95401
    // e.g. 218 B St, 95401
    let qual_addr = this.state.get('qualified_address').toJS();
    if(!qual_addr.address) {
      this.setState(this.state.set('qualified_address', Immutable.Map(result.response.request_address)));
    }
    this.setState(this.state.set('postal_address', Immutable.Map(result.response.postal_address)));

    if(this.state.get('prequal_stage') >= 1 && (this.state.get('videoPlaying') || this.state.get('bailOutForm'))) {
      this.setState(this.state.set('prequalInProgress', true));
      this.setState(this.state.set('serviceAvailable', false));
      this.setState(this.state.set('prequal_stage', 9));
      return true;
    }

    this.continuePrequal(result);
  }

  handleContinuePrequal(result) {
    this.continuePrequal(result);
  }

  continuePrequal(result) {
    // squall mdu responses

    if(result.response.reason == 'known_address_possible_unit'
      || result.response.reason == 'unknown_address_unit'
      || result.response.reason == 'unknown_address_empty_unit'
    ) {
      this.setState(this.state.set('prequalInProgress', true));
      this.setState(this.state.set('serviceAvailable', false));
      this.setState(this.state.set('showSquallMduModal', true));
      return;
    }

    if(result.response.reason == 'address_suggestions') {

      var suggestions = result.response.address_suggestions;

      var sano = this.state.getIn(['input_address', 'streetAddress']).split(/\s/)[0];

      var sanomatches = suggestions.filter((s) => s.SrvcAddrHousNbr == sano);
      if(sanomatches.length) {
        suggestions = sanomatches;
      }

      suggestions = suggestions.sort(
        firstBy("SrvcAddrStName")
          .thenBy("SrvcAddrHousNbr")
          .thenBy("SrvcAddrStDrctl")
          .thenBy("LocationDesignator1")
          .thenBy("LocationValue1")
        );

      this.setState(this.state.set('qual_suggestions', Immutable.List(suggestions)));
      this.setState(this.state.set('prequalInProgress', true));
      this.setState(this.state.set('serviceAvailable', false));
      this.setState(this.state.set('showSquallSuggestionsModal', true));
      this.setState(this.state.set('return_suggestions', false));
      return;
    }

    if(this.state.getIn(['input_address', 'secondary']) && !this.state.getIn(['qualified_address', 'unit'])) {
      this.setState(this.state.setIn(['lastPrequal', 'response', 'reason'], 'unknown_address_unit'));

      this.setState(this.state.set('prequalInProgress', true));
      this.setState(this.state.set('serviceAvailable', false));
      this.setState(this.state.set('showSquallMduModal', true));

    //  this.setState(this.state.setIn(['qualified_address', 'unit'], this.state.getIn(['input_address', 'secondary'])));

      return;
    }

    this._handlePrequalResult(result);
  }

  /*
  expects regular object
  */
  _handlePrequalResult(result) {
    this.setState(this.state.set('prequalInProgress', false));

    if(!result.response.service_available ) {

      // SP-6532 Show business seats page even with no service available.
      // then, if enterprise, it will redirect to the business-offerings "Let's Chat" page
      if(this.state.getIn(['input_address', 'serviceType']) == 'business') {
        this.showBusinessType();
        return true;
      }

      this.setState(this.state.set('serviceUnavailableReason', "no_products"));

      this.setState(this.state.setIn(['contact_info', 'contact_type'], (this.state.getIn(['input_address', 'serviceType']) == 'business' ? 'busnotyet' : 'resnotyet')));
      return;
    }

    if(result.response.products_available.reseller) {
      this.setState(this.state.set('reseller', Immutable.List(result.response.products_available.reseller)));
      return;
    }

    this.setState(this.state.set('serviceAvailable', result.response.service_available));

    if('undefined' !== typeof result.response.products_available.hpbx_with_access) {
      this.showBusinessType();
      this.setState(this.state.setIn(['input_address', 'serviceType'], 'business'));
      var products = Immutable.fromJS(result.response.products_available.hpbx_with_access);
      this.setState(this.state.set('products', products));

      	let is_bpf = products.toJS().filter(function(product) {
	            return typeof product.is_fttb != 'undefined' && product.is_fttb;
	    }).length;

        if (is_bpf) {
            let url_params = this._getBusinessOfferingsUrlParams(is_bpf);
            let base = window.develorigin ? window.develorigin : window.location.origin;
            let url = base+"/business-offerings?"+url_params;

            window.location.assign(url);
            this.setState(this.state.set('redirect', true));
            return;
        }
    }



    if(this.state.getIn(['input_address', 'serviceType']) == 'business') {
      return true;
    }

    var fiber_xgspon_available, fiber_available, fttn_available, fusion_available, voice_only_available, fusion_fiber_data_flat_rate_available;
    var coupon_codes = {};
    for(var i = 0; i < result.response.products_available.fusion.length; i++) {
      var product = result.response.products_available.fusion[i];

      if(product.product_key.indexOf('xgspon') !== -1) {
        this.setState(this.state.set('fiber_xgspon_available', true));
        fiber_xgspon_available = true;

        this.setState(this.state.set('fiber_product', Immutable.Map(product)));
      }
      else if(product.product_key.indexOf('fiber') !== -1) {
        this.setState(this.state.set('fiber_available', true));
        fiber_available = true;
        if(product.product_key != 'fusion_fiber_lifeline') {
          this.setState(this.state.set('fiber_product', Immutable.Map(product)));
        }
      }
      else if(product.product_key.indexOf('ipbb') !== -1) {
        this.setState(this.state.set('fttn_available', true));
        fttn_available = true;
      }
      else if(product.product_key.indexOf('voice_only') !== -1) {
        this.setState(this.state.set('voice_only_available', true));
        voice_only_available = true;
      }
      else {
        this.setState(this.state.set('fusion_available', true));
        fusion_available = true;
      }

      if(product.product_key.indexOf('fusion_fiber_data_flat_rate') !== -1) {
        fusion_fiber_data_flat_rate_available = true;
        this.setState(this.state.set('fusion_fiber_data_flat_rate_available', true));
      }

      if(product.promo && product.promo.code) {
        coupon_codes[product.promo.code] = product.promo;
      }
    }

    if(fusion_fiber_data_flat_rate_available) {
      result.response.products_available.fusion = result.response.products_available.fusion.map(function(product) {
        if(product.product_key.indexOf('fusion_fiber_data_flat_rate') !== -1) {
          product.recommended = true;
        } else {
          product.recommended = false;
        }
        return product;
      });

      let flat_rate_products = result.response.products_available.fusion.filter(function(product) {
        return product.product_key.indexOf('fusion_fiber_data_flat_rate') !== -1;
      });

      result.response.products_available.fusion = result.response.products_available.fusion.filter(function(product) {
        return product.product_key.indexOf('fusion_fiber_data_flat_rate') === -1;
      });

      result.response.products_available.fusion = result.response.products_available.fusion.concat(flat_rate_products);
    }


    var products = Immutable.fromJS(result.response.products_available.fusion);

    this.setState(this.state.set('products', products));

    if(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 992
      || this.state.get('products').toJS().length == 1
    ) {
      this.setState(this.state.set('showConfigure', true));
    }
    else {
      this.setState(this.state.set('showConfigure', true));
    }

    if(!this.state.get('fiber_xgspon_available') && !this.state.get('fiber_available')) {
      this.setState(this.state.set('show_additional_products', true));
    }

  }

  _getBusinessOfferingsUrlParams(is_bpf) {

        let qual_addr = this.state.get('qualified_address').toJS();
        console.log('test3');
        let query_string = [];

	    query_string.push('prequal_tracking_key='+this.state.get('prequal_tracking_key'));

	    if(is_bpf) {
	        query_string.push('is_bpf=1');
	    }

	    if(this.state.getIn(['lastPrequal', 'response', 'is_preorder_address'])) {
	    	query_string.push('pre=1');
	    }

	    for(var i in qual_addr) {
	      if(qual_addr.hasOwnProperty(i)) {
	        query_string.push(encodeURIComponent(i) + "=" + encodeURIComponent(qual_addr[i]));
	      }
	    }
	    return query_string.join("&");
  }

  handleUpdateSuggestions(suggestions) {

    if(typeof suggestions[0] != 'undefined' && typeof suggestions[0].error != 'undefined') {
      this.setState(this.state.set('errorMessage', suggestions[0].error));
    }
    else {
      this.setState(this.state.set('suggestions', Immutable.List(suggestions)));

      this.setState(this.state.set('errorMessage', null));
    }
  }

  handleSuggestionsFailed(errorMessage) {
    this.setState(this.state.set('errorMessage', errorMessage));
  }

  // mark address as unverified
  handleUpdateStreetAddress(streetAddress) {
    this.setState(this.state.setIn(['input_address', 'verified'], false));

    if(streetAddress != this.state.getIn(['verified_address', 'delivery_line_1']) ) {
      this.setState(this.state.set('verified_address', Immutable.Map({})));
    }

    this.setState(this.state.setIn(['input_address', 'streetAddress'], streetAddress));
    this.setState(this.state.setIn(['input_address', 'streetAddress_valid'], /^([\w\d]+) (.+)/.test(streetAddress)));
  }

  handleUpdateZip(zip) {

    this.setState(this.state.set('verified_address', Immutable.Map({})));
    this.setState(this.state.setIn(['input_address', 'verified'], false));
    this.setState(this.state.setIn(['input_address', 'zip'], zip));
    this.setState(this.state.setIn(['input_address', 'zip_valid'], /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)));
  }

  handleUpdateSecondary(secondary) {
    this.setState(this.state.setIn(['input_address', 'secondary'], secondary));
  }

  handleSuggestionSelected(suggestion) {
    var components = {};
    var gmaps = suggestion.gmaps.address_components;
    var foundStreet = false;

    for(var i in gmaps) {
      if(!gmaps[i] || typeof gmaps[i] == 'function' || !gmaps[i].types) {
        continue;
      }
      components[gmaps[i].types[0]] = gmaps[i].short_name;
      if (gmaps[i].types[0] == 'street_number') {
        foundStreet = true;
      }
    }

    if (!foundStreet) {
    // usually happens if the street # is invalid, or possibly if unknown to google places (new developments)
      components.street_number = '';
      var match = this.state.getIn(['input_address', 'streetAddress']).match(/^([\d\w]+)/);
      if (null !== match) {
        components.street_number = match[1];
      }
    }

    this.setState(this.state.setIn(['input_address', 'streetAddress'], components.street_number + ' ' + components.route));
    this.setState(this.state.setIn(['input_address', 'city'], components.locality));
    this.setState(this.state.setIn(['input_address', 'state'], components.administrative_area_level_1));
    this.setState(this.state.setIn(['input_address', 'zip'], components.postal_code));

    this.setState(this.state.setIn(['input_address', 'streetAddress_valid'], true));
    this.setState(this.state.setIn(['input_address', 'zip_valid'], true));
  }



  handleAddressVerified(verify_obj) {
    var candidates = verify_obj.candidates;
    var addr_to_verify = verify_obj.addr_to_verify;

    this.setState(this.state.setIn(['input_address', 'verificationRan'], true));

    if(!candidates.length) {
      this.setState(this.state.set('verification_failed', true));

      return;
    } else {
      this.setState(this.state.delete('verification_failed'));
    }

    var candidate = candidates[0];


    this.setState(this.state.setIn(['input_address', 'streetAddress'], candidate.delivery_line_1));
    this.setState(this.state.setIn(['input_address', 'city'], candidate.components.city_name));
    this.setState(this.state.setIn(['input_address', 'state'], candidate.components.state_abbreviation));
    this.setState(this.state.setIn(['input_address', 'zip'], candidate.components.zipcode + (candidate.components.plus4_code ? '-'+candidate.components.plus4_code : '')));

    if(!this.state.get('service_type_manually_selected')) {
      this.setState(this.state.setIn(['input_address', 'serviceType'],(candidate.metadata.rdi == 'Commercial' ? 'business' : 'residential') ));
    }

    this.setState(this.state.set('verified_address', Immutable.fromJS(candidate)));

    this.setState(this.state.setIn(['input_address', 'verified'], true));
    this.setState(this.state.setIn(['input_address', 'streetAddress_valid'], true));
    this.setState(this.state.setIn(['input_address', 'zip_valid'], true));
  }

  showBusinessType() {
    this.setState(this.state.set('show_business_type', true));
    this.setState(this.state.setIn(['contact_info', 'contact_type'], 'BUSQuoteContactMe' ));

  }

  hideBusinessType() {

    this.setState(this.state.set('service_type_manually_selected', true));
    this.setState(this.state.set('show_business_type', false));
  }

}

AvailabilityStore.displayName = 'AvailabilityStore';

let myStore    = alt.createStore(ImmutableUtil(AvailabilityStore));
let localCache = new LocalStore(myStore, 'AvailabilityStore');

//localCache.restore();
export default myStore;
